export const toolbarSettings = {
    showLangSwitch: false,
  };
  